angular.module('unergie.main')
.directive('userInfoAccountLastConnection', (BoFeaturesService, Navigation, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountLastConnection.html',
        link($scope) {
            $scope.lastConnectionDate = null

            $scope.setAccountIdForGraph = () => (localStorage.navGraphIdAccount = $scope.account.id)

            const activate = function () {
                const feats = BoFeaturesService.getModuleFeatures('accountinfo')

                if (feats.lastConnection) {
                    return Navigation.lastConnection({ id_account: $scope.account.id })
                    .$promise.then((data) => ($scope.lastConnectionDate = data != null ? data.createdAt : undefined))
                    .catch(ErrorCatcher)
                }
            }

            return activate()
        },
    }),
)
